import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { RadioButton } from 'components'

import { usePhoneNotificationsService } from './usePhoneNotificationsService'
import { NotificationTypeEnum } from 'services/me/preferences'

import * as S from './styles'

export const PhoneNotifications: React.FC = () => {
  const { data, updatePhoneNotification } = usePhoneNotificationsService()

  const handleUpdatePhoneNotification = (selectedType: NotificationTypeEnum) => {
    if (data === selectedType) return

    return updatePhoneNotification(selectedType)
  }

  return (
    <S.Container>
      <Typography variant="content2">
        Receber lembretes por:
      </Typography>

      <S.RadioButtonsContainer>
        <RadioButton 
          radioId={NotificationTypeEnum.WHATSAPP}
          selected={data === NotificationTypeEnum.WHATSAPP}
          value={NotificationTypeEnum.WHATSAPP}
          onClickRadioButton={() => handleUpdatePhoneNotification(NotificationTypeEnum.WHATSAPP)}
          iconWidth='20px'
          iconHeight='20px'
          title='WhatsApp'
        />

        <RadioButton 
          radioId={NotificationTypeEnum.SMS}
          selected={data === NotificationTypeEnum.SMS}
          value={NotificationTypeEnum.SMS}
          onClickRadioButton={() => handleUpdatePhoneNotification(NotificationTypeEnum.SMS)}
          iconWidth='20px'
          iconHeight='20px'
          title='SMS'
        />

      </S.RadioButtonsContainer>
    </S.Container>
  )
}